<template>
    <div @click="$emit('click', !value)" class="cursor-pointer">
        <Icon :icon="[ 'far', 'circle' ]" v-if="!value" class="text-secondary" />
        <Icon icon="check-circle" class="text-dark" v-else />
    </div>
</template>

<script>
    export default {
        props: {
            value: Boolean
        }
    }
</script>